/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export const TAB_STATE = {
	SHOW_SLOTS: 'show_slots',
	SHOW_DATA: 'show_data'
};

class SlotsContainer extends Component {

	componentDidMount(){
		this.renderSlots();
	}

	componentDidUpdate(prevProps) {
		if (this.props.widget !== prevProps.widget) {
			this.renderSlots();
		}
	}

	componentWillUnmount() {
		this.exploreSlotsRef = null;
	}

	render() {
		return (
			<div className="explore-slots" ref={(node) => this.exploreSlotsRef = node}></div>
		);
	}

	renderSlots(){
		const { dashboardApi } = this.props;
		const slotDOMFeature = dashboardApi.getFeature('SlotEditorDOM');
		const parentNode = this.exploreSlotsRef;
		if( parentNode && slotDOMFeature ){
			slotDOMFeature.render({ parentNode });
		}
	}
}

SlotsContainer.propTypes = {
	widget: PropTypes.object.isRequired,
	dashboardApi: PropTypes.object.isRequired
};

export default SlotsContainer;



// WEBPACK FOOTER //
// ./src/js/components/slotsContainer/SlotsContainer.js